<!-- TODO: implement search -->
<kor-input
  type="search"
  [label]="!tagSearchTerm ? 'find products, patterns or elements' : false"
  (input)="
    tagSearchTerm = $event.target.value; sharedService.logEvent('search_input')
  "
></kor-input>

<!-- tags -->
<div *ngFor="let filter of filters">
  <h3>{{ filter.label }}</h3>
  <hr />
  <div class="tags">
    <ng-container *ngFor="let doc of filter.docs">
      <kor-tag
        *ngIf="tagSearchTerm ? containsSearchTerm(doc.keywords) : true"
        class="toggle"
        [label]="doc.name"
        [ngClass]="{
          active: filterService.filters[filter.colUid]?.includes(doc.uid)
        }"
        (click)="
          filterService.applyFilter(filter.colUid, doc.uid);
          sharedService.logEvent('tag_clicked', {
            label: filter.label + '_' + doc.name
          })
        "
      ></kor-tag>
    </ng-container>
  </div>
</div>

<!-- TEMPORARY: contact banner -->
<hr />
<div>
  <kor-card class="banner">
    <h3 slot="header">contribute to gleemo</h3>
    let us know which apps you'd like to see added or features you think are
    missing.
    <a
      href="mailto:eduferferr@gmail.com?subject=gleemo suggestion"
      slot="footer"
      (click)="sharedService.logEvent('contact_clicked')"
    >
      <kor-button label="share your thoughts"></kor-button>
    </a>
  </kor-card>
</div>
